<template>
  <b-form @submit.prevent="search">
    <!--SEARCH FIELD-->
    <b-form-group
      id="search-group"
      style="margin-bottom: 0"
      label-for="search"
    >
      <div class="d-flex">
        <b-form-input
          ref="input"
          @input="searchInput"
          id="search"
          type="search"
          v-model="searchString"
          :placeholder="searchPlaceholder"
          :autofocus="autofocus"
        ></b-form-input>
        <b-button
          class="ml-1"
          variant="outline-secondary"
          type="submit" >
          <b-icon :icon="iconName"></b-icon>
        </b-button>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
  import i18n from '@base/i18n'

  export default {
    name: 'SearchField',

    data () {
      return  {
        searchString: null
      }
    },

    props: {
      searchPlaceholder: {
        type: String,
        default: i18n.t('table.general.search')
      },
      autofocus: {
        type: Boolean,
        default: false,
      },
      iconName: {
        type: String,
        default: 'search',
      },
    },

    methods: {
      searchInput () {
        this.$emit('input', this.searchString)
        if (!this.searchString)
          this.search()
      },

      search () {
        this.$emit('search', this.searchString)
      },

      clear () {
        this.searchString = null
      },

      focus () {
        // Surface the inner BFormInput's DOM input so callers can refocus
        // (e.g. after a barcode-scan add cycle in the POS view).
        const inner = this.$refs.input
        if (!inner) return
        if (typeof inner.focus === 'function') {
          inner.focus()
        } else if (inner.$el) {
          const el = inner.$el.querySelector('input')
          if (el) el.focus()
        }
      },
    },
  }
</script>

<style scoped>

</style>
